/**
 * Search Input
 *
 * @selector [data-js-search-input]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export default class SearchInput extends BaseModule {
    init(element) {
        this.el = element;
        this.$el = $(element);

        this.on('focus', this.onFocus);
        this.on('blur', this.onBlur);
        this.on('change', this.onChange);

        return this;
    }

    onFocus() {
        document.documentElement.classList.add('is-search-focused');
    }

    onBlur() {
        document.documentElement.classList.remove('is-search-focused');
    }

    onChange() {
        this.el.blur();
    }
}
